module.exports = __webpack_public_path__ + "static/our-culture-whats-left-of-it-ee29a3ac4af8197fcaa80d619489a6f8.jpg";